import React from 'react';
import { Button, Card, Descriptions, Space, Spin, Table, Tag, Typography } from 'antd';
import { ArrowLeftOutlined, CopyOutlined } from '@ant-design/icons';
import { formatDate } from 'utils/date';
import SampleDataModal from './SampleDataModal';

const { Title } = Typography;

const Desktop = ({ viewModel }) => {
  const {
    workspace,
    history,
    loading,
    isInvalidateShop,
    packageStatusLabel,
    packageStatusColor,
    goBack,
    demoCredentials,
    copyText,
    copyAllDemoCredentials,
    sampleModalOpen,
    sampleSubmitting,
    openSampleModal,
    closeSampleModal,
    createSampleData,
  } = viewModel;

  const tier = workspace?.subscription?.tier || 'mien_phi';
  const isInvalid = isInvalidateShop(workspace);

  const historyColumns = [
    {
      title: 'Gói',
      render: (_, record) => record.package_name || record.package_key || '-',
    },
    {
      title: 'Thời hạn',
      render: (_, record) => `${record.total_months || record.duration_months || '-'} tháng`,
    },
    {
      title: 'Số tiền',
      dataIndex: 'amount',
      render: (val) => (val ? `${Number(val).toLocaleString('vi-VN')} ₫` : '-'),
    },
    {
      title: 'Trạng thái',
      dataIndex: 'status',
      render: (val) => <Tag color={packageStatusColor(val)}>{packageStatusLabel(val)}</Tag>,
    },
    {
      title: 'Ngày tạo',
      dataIndex: 'create_on',
      render: (val) => formatDate(val) || '-',
    },
    {
      title: 'Ngày duyệt',
      dataIndex: 'approved_on',
      render: (val) => formatDate(val) || '-',
    },
  ];

  return (
    <Spin spinning={loading}>
      <div style={{ display: 'grid', gap: 16 }}>
        <Space>
          <Button icon={<ArrowLeftOutlined />} onClick={goBack}>Quay lại</Button>
          <Title level={4} style={{ margin: 0 }}>
            {workspace?.web_site?.title || '-'}
          </Title>
          {workspace?.is_demo || workspace?.shop_type === 'demo' ? <Tag color='blue'>Demo</Tag> : null}
          <Button type='primary' onClick={openSampleModal}>Tạo dữ liệu mẫu</Button>
        </Space>

        <Card title='Thông tin shop'>
          <Descriptions column={2}>
            <Descriptions.Item label='Tên shop'>{workspace?.web_site?.title || '-'}</Descriptions.Item>
            <Descriptions.Item label='Domain'>
              <a href={`https://${workspace?.web_site?.url}.sipro.store`} target='_blank' rel='noreferrer'>
                {workspace?.web_site?.url ? `${workspace.web_site.url}.sipro.store` : '-'}
              </a>
            </Descriptions.Item>
            <Descriptions.Item label='Ngày tạo'>{formatDate(workspace?.create_on) || '-'}</Descriptions.Item>
            <Descriptions.Item label='Chủ shop'>{workspace?.owner?.full_name || '-'}</Descriptions.Item>
            <Descriptions.Item label='Số điện thoại'>{workspace?.owner?.phone || '-'}</Descriptions.Item>
            <Descriptions.Item label='Email'>{workspace?.owner?.email || '-'}</Descriptions.Item>
            <Descriptions.Item label='Sản phẩm'>{workspace?.product_count ?? '-'}</Descriptions.Item>
            <Descriptions.Item label='Đơn tháng này'>{workspace?.order_count_month ?? '-'}</Descriptions.Item>
          </Descriptions>
        </Card>

        <Card title='Gói cước đang sử dụng'>
          <Descriptions column={2}>
            <Descriptions.Item label='Gói'>
              <Space>
                <span>{isInvalid ? 'invalidate' : (tier || '-')}</span>
                {isInvalid ? <Tag color='red'>Invalidate</Tag> : null}
              </Space>
            </Descriptions.Item>
            {tier !== 'mien_phi' && (
              <Descriptions.Item label='Hết hạn'>
                {formatDate(workspace?.subscription?.expiry_on) || '-'}
              </Descriptions.Item>
            )}
          </Descriptions>
        </Card>

        {demoCredentials && (
          <Card
            title={
              <Space>
                <span>Thông tin đăng nhập demo</span>
                <Button size='small' icon={<CopyOutlined />} onClick={copyAllDemoCredentials}>Copy tất cả</Button>
              </Space>
            }
          >
            <Descriptions column={1}>
              <Descriptions.Item label='Login ID'>
                <Space>
                  {demoCredentials.login_id || '-'}
                  {demoCredentials.login_id && (
                    <Button size='small' icon={<CopyOutlined />} onClick={() => copyText(demoCredentials.login_id, 'Login ID')} />
                  )}
                </Space>
              </Descriptions.Item>
              <Descriptions.Item label='Mật khẩu'>
                <Space>
                  {demoCredentials.password || '-'}
                  {demoCredentials.password && (
                    <Button size='small' icon={<CopyOutlined />} onClick={() => copyText(demoCredentials.password, 'mật khẩu')} />
                  )}
                </Space>
              </Descriptions.Item>
              <Descriptions.Item label='URL'>
                <Space>
                  <a href={`https://${workspace?.web_site?.url}.sipro.store`} target='_blank' rel='noreferrer'>
                    {workspace?.web_site?.url ? `${workspace.web_site.url}.sipro.store` : '-'}
                  </a>
                  {workspace?.web_site?.url && (
                    <Button size='small' icon={<CopyOutlined />} onClick={() => copyText(`https://${workspace.web_site.url}.sipro.store`, 'URL')} />
                  )}
                </Space>
              </Descriptions.Item>
            </Descriptions>
          </Card>
        )}

        <Card title='Lịch sử nâng hạ gói'>
          <Table
            rowKey={(record) => record.id || record.create_on}
            columns={historyColumns}
            dataSource={history}
            pagination={false}
            locale={{ emptyText: 'Chưa có lịch sử' }}
          />
        </Card>

        <SampleDataModal
          open={sampleModalOpen}
          loading={sampleSubmitting}
          onCancel={closeSampleModal}
          onSubmit={createSampleData}
        />

      </div>
    </Spin>
  );
};

export default Desktop;
